export default {
  common: {
    yes: 'Yes',
    no: 'No',
    currency: { php: 'PHP', vnd: 'VND', cny: 'CNY', all: 'All Currencies' },
    status: {
      sufficient: 'Sufficient {pct}%',
      warning: 'Warning {pct}%',
      exhausted: 'Exhausted',
      unallocated: 'Unallocated',
    },
    change: { add: '+ Add', sub: '- Reduce', consume: 'Adjustment Consumed' },
    remaining: 'Remaining',
    totalAmount: 'Total Quota',
    usedAmount: 'Used',
    noPermission: '- No Permission -',
    self: '(Self)',
    exportExcel: 'Export Excel',
  },
  sys: {
    column: {
      title: 'User Adj. Quota',
      subtitle: 'Available / Total',
      subtitleNew: 'Platform admin · Member adjust',
      tagRefactor: 'refactored',
    },
    btn: { manage: 'Quota Manage', manageNew: 'New' },
    section: {
      userTitle: 'User Adjustment Quota',
      userSubtitle: 'Platform admin · Member balance adjust',
      agentTitle: 'Agent Allocation Quota',
      agentSubtitle: 'Marketing · Allocate to agents',
    },
    manage: {
      title: 'Account Quota Management',
      totalUsed: 'Total Used: ',
      remainingLabel: 'Remaining',
      monthlyConsumed: 'This Month',
      monthlyUser: 'User',
      monthlyAgent: 'Agent',
      viewAllPrefix: 'View all quota change records',
      viewAllLink: 'Quota Change Log',
      recentChanges: 'Recent Changes',
      recentChangesSub: 'Last 5',
      viewAll: 'View Full Detail →',
      memberLabel: 'Member',
      typeAdd: '+ Add',
      typeSub: '- Reduce',
      typeConsume: 'Adjustment Consumed',
      col: {
        time: 'Time',
        type: 'Type',
        currency: 'Currency',
        change: 'Change',
        afterRemain: 'After',
        operatorRemark: 'Operator / Remark',
      },
    },
    adjust: {
      title: 'Adjust Quota',
      opType: 'Operation Type',
      add: '+ Add',
      sub: '- Reduce',
      amount: 'Amount ({currency})',
      reason: 'Reason',
      reasonPlaceholder: 'Please enter the reason for this quota change (for audit)',
      reasonMaxLen: 'Max 100 characters',
      amountRequired: 'Please enter amount',
      amountMin: 'Amount must be greater than 0',
      reasonRequired: 'Please enter reason',
      preview: {
        after: '→ After: Remaining {remain} / Total {total}',
        error: '⚠ Cannot reduce by this amount; it exceeds the remaining available quota ({remain})',
      },
      myAvailable: 'My available ({currency})',
      myQuotaEmpty: '⚠ You have no remaining agent allocation quota. Please ask a super admin to top up before adding.',
      exceedMyQuota: '⚠ Exceeds your available quota ({myAvailable}); cannot add this much.',
      singleLimit: {
        exceeded: 'Single {dir} limit is {cur} {max}; this transaction {cur} {amount} exceeds it',
        add: 'increase',
        reduce: 'decrease',
      },
      success: 'Success',
      fail: 'Failed',
    },
  },
  financial: {
    title: 'Quota Change Log',
    desc: 'Records all quota changes for backend accounts: ① Quota Adjust (admin manually adjusts account quota); ② Member Adjust (consumed when operator performs manual member balance adjustment). Before/after shows (Available / Total).',
    tab: {
      opUser: 'Backend Account Quota',
      agentAlloc: 'Agent Allocation',
      agentBetween: 'Inter-Agent Allocation',
      memberAlloc: 'Player Allocation',
      opUserGrant: 'Agent Quota Grant Records',
    },
    usage: {
      allocate: 'Allocate',
      recycle: 'Recycle',
    },
    targetTag: {
      opUser: 'Backend Account',
      agent: 'Agent',
      member: 'Player',
    },
    level: {
      platform: 'Platform',
      l1: 'L1 Agent',
      l2: 'L2 Agent',
      agent: 'Agent',
      superAdmin: 'Super Admin',
    },
    filter: {
      timeRange: 'Change Time',
      startDate: 'Start Date',
      endDate: 'End Date',
      operator: 'Operator',
      operatorPlaceholder: 'Operator account',
      targetAccount: 'Target Account',
      targetPlaceholder: 'Target backend account',
      agentAccount: 'Target Agent',
      agentPlaceholder: 'Search agent account',
      memberAccount: 'Target Player',
      memberPlaceholder: 'Search player account',
      bizType: 'Change Type',
      bizTypeAll: 'All Types',
      currency: 'Currency',
      currencyAll: 'All Currencies',
    },
    bizType: {
      adjustConsume: 'Member Adjust',
      quotaAdjust: 'Quota Adjust',
      opUserRefundFromMember: 'Member Deduct Refund',
    },
    col: {
      id: 'ID',
      time: 'Change Time',
      usage: 'Usage',
      operator: 'Operator',
      operatorLevel: 'Operator Level',
      adjustReason: 'Adjust Reason',
      refundFlag: 'Quota Recycled',
      countPayDeposit: 'Counted in Deposit/Withdrawal',
      targetAccount: 'Target Account',
      targetMember: 'Target Member',
      currency: 'Currency',
      bizType: 'Change Type',
      changeAvailable: 'Available Change',
      changeTotal: 'Total Change',
      beforeAfterAvailable: 'Before → After (Available)',
      beforeAfterTotal: 'Before → After (Total)',
      grantAmount: 'Granted Amount',
      grantAmountSub: 'Available & total increase together',
      afterQuota: 'After Change',
      afterQuotaSub: 'Available / Total',
      bizNo: 'Biz No.',
      remark: 'Remark',
    },
  },
  my: {
    menuItem: 'My Adjustment Quota',
    modal: { title: 'My Adjustment Quota' },
    desc: 'View your current adjustment quota and change history. Contact an admin with "Account Quota Management" permission to add quota.',
    hero: { onlySelf: 'Current login account · Visible only to yourself', monthConsumed: 'This Month Consumed: ', account: 'Account', role: 'Role' },
    currentQuota: { title: 'Current Available Quota', subtitle: 'Real-time · Auto-refreshed after each adjustment' },
    agentAlloc: {
      title: 'Agent Allocation Quota',
      subtitle: 'Allocate quota to agents (L1/L2) · Real-time · auto-refreshed after allocate/recycle',
      monthUsed: 'Used this month',
    },
    card: { remainLabel: 'Remaining Quota', total: 'Total: {val}', monthUsed: 'This Month: {val}' },
    filter: {
      time7d: 'Last 7 Days', time30d: 'Last 30 Days',
      timeMonth: 'This Month', timeLastMonth: 'Last Month',
      allCurrencies: 'All Currencies', allTypes: 'All Types',
      consumeType: 'Adjustment Consumed', addType: 'Admin Added', subType: 'Admin Reduced',
    },
    table: {
      time: 'Time', type: 'Type', currency: 'Currency',
      amount: 'Amount', afterRemain: 'Remaining After', detail: 'Member / Detail',
    },
    total: '{count} records total',
  },
  chip: {
    label: 'My Quota',
    unallocated: 'Unallocated',
    tooltip: 'Click to view my adjustment quota',
  },
  opuser: {
    agent: {
      column: {
        title: 'Agent Adj. Quota',
        subtitle: 'Marketing · Allocate to agents',
        tagNew: 'NEW',
      },
      btn: { manage: 'Agent Quota', manageNew: 'NEW' },
      manage: {
        title: 'Agent Allocation Pool',
        banner: 'This is the operator\'s pool for allocating to agents. Independent of the user-adjust quota on the left.',
      },
      adjust: { title: 'Adjust Agent Allocation Pool', success: 'Success', fail: 'Failed' },
    },
  },
  agent: {
    btn: { manage: 'Quota' },
    column: { title: 'Current Quota', subtitle: 'Used / Available' },
    whitelist: {
      bannerTitle: 'Whitelist authorization: ',
      bannerDesc:
        'This agent can ONLY adjust members in the whitelist. Default empty = the agent cannot adjust any member. Operations admins are not affected.',
      addBtn: '+ Add Member',
      downloadTemplate: 'Template',
      batchImportBtn: 'Batch Import',
      totalText: 'Total {count}',
      search: { placeholder: 'Search account', btn: 'Search' },
      stats: {
        whitelistCount: 'Whitelisted:',
        directCount: 'Direct members:',
        coverRate: 'Cover rate:',
        unit: '',
        emptyHint: 'Default empty: agent cannot adjust any member',
      },
      col: {
        account: 'Account',
        vipLevel: 'VIP',
        addTime: 'Added At',
        addedBy: 'By',
        action: 'Action',
      },
      add: {
        accountLabel: 'Member Account',
        placeholder: 'Enter the full member account',
        accountRequired: 'Account is required',
        helpText: 'Member must exist and belong to this agent',
        success: 'Added',
        alreadyExists: 'Member is already in the whitelist',
      },
      failReason: {
        MEMBER_NOT_FOUND: 'Member not found',
        NOT_DIRECT_MEMBER: 'Member does not belong to this agent',
        QUERY_ERROR: 'Query failed',
      },
      remove: {
        btn: 'Remove',
        confirmTitle: 'Confirm removal',
        confirmContent: 'Remove {account} from whitelist. The agent will no longer be able to adjust this member.',
        success: 'Removed',
      },
      batchImport: {
        title: 'Batch Import Members',
        helpText: 'Upload a CSV / TXT file, or paste accounts (one per line, # = comment).',
        uploadBtn: 'Upload CSV / TXT',
        placeholder: 'Paste accounts here, one per line',
        submit: 'Import',
        empty: 'Please provide at least one account',
        done: 'Done — added {added}, skipped {skipped}, failed {failed}',
        added: '✓ Added',
        skipped: '⚠ Skipped (already exists)',
        failed: '✗ Failed',
      },
    },
    manage: {
      title: 'Agent Adjustment Quota',
      accountLabel: 'Account',
      monthlyConsumedLabel: 'This Month',
      monthConsumed: 'This Month',
      poolTitle: 'Adjustment Quota (Single Pool)',
      poolHint:
        'Notes: L1 single pool — adjustment quota covers BOTH manual member adjustments AND allocations to L2 sub-agents. The pool is shared; they do not separate.',
      typeAllocateIn: '↓ Allocated In',
      typeAllocateOut: '↑ Allocated Out',
      tab: {
        quota: 'Quota',
        memberConfig: 'Member Config',
      },
      memberConfigComingSoon:
        'This tab is a placeholder. It is decoupled from quota and will be wired to its own API later.',
    },
  },
  wallet: {
    operatorRow: {
      operator: 'Operator: ',
      willDeduct: 'This adjustment will deduct your "{currency}" quota',
      viewDetail: 'View Full Detail →',
    },
    preview: {
      after: '→ Remaining after: {remain} {currency}',
      insufficient: '→ Insufficient by {amount} {currency}',
      viewDetail: 'View Detail →',
    },
    banner: {
      title: 'This Adjustment Will Be Blocked',
      desc: 'Cannot submit: adjustment amount ({amount}) exceeds your remaining quota ({remain} {currency}). Please contact an admin with "Account Quota Management" permission.',
    },
  },
};
